/**
 * Calculate the forecast ADR using forecast revenue and total forecast
 */
export const calculateForecastADR = (
	fcstRev: number,
	totalFcst: number,
	override: number,
) => {
	const overridePercent = override / 100;
	const forecastADR = Number.parseInt((fcstRev / totalFcst).toFixed(2));
	if (Number.isNaN(forecastADR)) return 0;
	if (overridePercent === 0) return forecastADR;
	const adjustment = Number.parseInt(
		(forecastADR * overridePercent).toFixed(2),
	);
	return forecastADR + adjustment;
};

/**
 * Calculate the ratio of group rate to transient rate
 */
export const calculateGroupRatio = (
	data: any[],
	groupRate: number,
	rooms: number,
) => {
	const totalRoomNights = rooms * data.length;
	const groupRevenue = totalRoomNights * groupRate;
	const equivalentTransientRevenue = data.reduce((acc, day) => {
		return acc + day.current_rate * rooms;
	}, 0);

	return Math.round((groupRevenue / equivalentTransientRevenue) * 100) / 100;
};

/**
 * Calculate the suggested rate based on the desired ratio
 */
export const calculateSuggestedRate = (
	data: any[],
	rooms: number,
	ratio: number,
) => {
	const totalRoomNights = rooms * data.length;
	const rev = calculateRevenue(data, rooms, ratio);
	return Number((rev / totalRoomNights).toFixed(2));
};

/**
 * Calculate revenue based on data, rooms, and ratio
 */
export const calculateRevenue = (data: any[], rooms: number, ratio: number) => {
	const equivalentTransientRevenue = data.reduce((acc, day) => {
		return acc + day.current_rate * rooms;
	}, 0);

	return equivalentTransientRevenue * ratio;
};
